import { map } from 'rxjs/operators';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { BsDaterangepickerConfig, BsModalRef, BsModalService } from 'ngx-bootstrap';
import { CouponService } from '../../../../../service/api/builk/coupon.service';
import { ProjectProductModel } from '../../../../../model/builk/coupon/project-product.model';
import { CouponItemModel, CreateProjectCouponModel, CreateProjectFreeCouponModel } from './../../../../../model/builk/coupon/project-coupon.model';
import { LocalStorageService } from 'angular-2-local-storage';
import { ResponseCouponCodeEnum } from '../../../../../enum/builk/coupon/response-coupon-code.enum';
import { ProjectPackageItemModel } from '../../../../../model/builk/coupon/project-package.model';

@Component({
  selector: 'app-create-free-coupon',
  templateUrl: './create-free-coupon.component.html',
  styleUrls: ['./create-free-coupon.component.scss']
})
export class CreateFreeCouponComponent {
  @ViewChild("template") template: TemplateRef<any>;
  @ViewChild("templateEdit") templateEdit: TemplateRef<any>;

  modalRef: BsModalRef;

  @Output() isSaved = new EventEmitter();
  @Output() okEvent = new EventEmitter();
  @Output() openNewProduct = new EventEmitter();

  // model
  couponModel: CreateProjectFreeCouponModel = new CreateProjectFreeCouponModel();
  editCouponModel: CouponItemModel = new CouponItemModel();
  invalid = {
    packageId: false,
    productId: false,
    couponCode: false,
    issueCountLimit: false,
    period: false,
    description: false,
  }

  // array
  productList: Array<ProjectProductModel> = [];
  discountType: Array<{ value: any, label: string }> = [
    { value: 1, label: "Percentage %" },
    { value: 2, label: "Amount" }
  ];
  periodDate: Array<Date> = [];
  packageId: Array<any> = [];
  packageList: Array<ProjectPackageItemModel> = [];
  tempPackageCondition: Array<number> = [];

  // boolean
  isLoading: boolean = false;
  isCreating: boolean = false;

  // number
  productId: number;
  discountTypeValue: number = 1;
  responseCouponCode: number = 0;

  // string
  //periodDate: string;
  bsConfig: Partial<BsDaterangepickerConfig> = {
    containerClass: 'theme-blue',
    rangeInputFormat: 'DD/MM/YYYY'
  };

  constructor(
    private modalService: BsModalService,
    private couponService: CouponService,
    private localStorageService: LocalStorageService
  ) { }

  openModal(): void {
    this.productId = null;
    this.discountTypeValue = 1;
    this.periodDate = [];
    this.packageId = [];
    this.couponModel = new CreateProjectCouponModel();
    this.initValidate();
    this.getProduct();
    this.getPackage();
    this.modalRef = this.modalService.show(this.template, {
      class: "modal-lg"
    });
  }

  edit(value: CouponItemModel): void {
    this.productId = value.projProdSurrKey;
    this.discountTypeValue = value.couponCalcType;
    this.periodDate = [new Date(value.couponStartDate), value.couponEndDate != null ? new Date( value.couponEndDate) : new Date()];
    this.periodDate = this.periodDate.map(val => val);
    this.tempPackageCondition = value.couponPackageCondition.map(val => val);
    this.packageId = [];
    this.getProduct();
    this.getPackage(true);
    this.editCouponModel = {
      couponSurrKey: value.couponSurrKey,
      couponCode: value.couponCode,
      couponCalcType: value.couponCalcType,
      couponStartDate: value.couponStartDate,
      couponEndDate: value.couponEndDate,
      couponDiscountValue: value.couponDiscountValue,
      couponMinimumDiscount: value.couponMinimumDiscount,
      couponMaximumDiscount: value.couponMaximumDiscount,
      couponQuotaLimit: value.couponQuotaLimit,
      couponCompanyQuotaLimit: value.couponCompanyQuotaLimit,
      createUserId: value.createUserId,
      couponPackageCondition: value.couponPackageCondition,
      projProdSurrKey: value.projProdSurrKey,
      couponDescription: value.couponDescription,
      isActive: value.isActive,
      isDelete: value.isDelete,
      couponCount: value.couponCount,
      projProdName: value.projProdName,
    }
    //this.editCouponModel = value;

    this.modalRef = this.modalService.show(this.templateEdit, {
      class: "modal-lg"
    });
  }

  initValidate() {
    this.invalid = {
      packageId: false,
      productId: false,
      couponCode: false,
      issueCountLimit: false,
      period: false,
      description: false,
    }
  }

  close(): void {
    this.modalRef.hide();
  }

  openProduct(): void {
    this.close();
    this.openNewProduct.emit(true)
  }

  getProduct(): void {
    this.isLoading = true;
    this.couponService.getProduct().subscribe(res => {
      if (res !== null && res.length > 0) {
        this.productList = res;
      }
      this.isLoading = false;
    }, err => {
      console.log(err.message);
      this.isLoading = false;
    }, () => {
      this.isLoading = false;
    });
  }

  getPackage(isEdit?: boolean): void {
    this.isLoading = true;
    this.couponService.getPackage().subscribe(res => {
      if (res !== null && res.length > 0) {
        this.packageList = res;
        if (isEdit) {
          this.tempPackageCondition.forEach((val, index) => {
            var item = this.packageList.find(pv => pv.packageSurrkey == val);
            if (item !== null && item !== undefined) {
              this.packageId.push({
                packageSurrkey: item.packageSurrkey,
                packageName: item.packageName
              }) 
            }
          })
          this.packageId = this.packageId.map(val => val)
        }
      }
      this.isLoading = false;
    }, err => {
      console.log(err.message);
      this.isLoading = false;
    }, () => {
      this.isLoading = false;
    });
  }

  save(): void {
    this.couponModel.couponPackageCondition = this.packageId.map(val => val.packageSurrkey);
    if (this.validateCoupon() == false) {
      return;
    }
    this.isCreating = true;
    this.couponModel.createUserId = this.localStorageService.get("userSurrKey");
    this.couponModel.couponPackageCondition = this.packageId.map(val => val.packageSurrkey);
    this.couponModel.projProdSurrKey = this.productId;

    let preData: CreateProjectFreeCouponModel = {
      couponCode: this.couponModel.couponCode,
      couponStartDate: this.periodDate[0].toISOString(),
      couponEndDate: this.periodDate[1].toISOString(),
      couponQuotaLimit: this.couponModel.couponQuotaLimit != null ? Number(this.couponModel.couponQuotaLimit) : null,
      createUserId: this.couponModel.createUserId,
      couponPackageCondition: this.couponModel.couponPackageCondition,
      projProdSurrKey: this.couponModel.projProdSurrKey,
      couponDescription: this.couponModel.couponDescription
    }

    // save
    this.couponService.createFreeCoupon(preData).subscribe(res => {
      if (res !== null) {
        if (res[0].statusCode == ResponseCouponCodeEnum.createSuccess) {
          this.responseCouponCode = res[0].statusCode;
          this.invalid.couponCode = false;
          this.isSaved.emit(true);
          this.close();
        } else if (res[0].statusCode == ResponseCouponCodeEnum.lengthCharactorError) {
          this.responseCouponCode = res[0].statusCode;
          this.invalid.couponCode = true
          console.log("Invalid coupon code")
        }
      }
      this.isCreating = false;
    }, err => {
      console.log(err.message);
      this.isCreating = false;
    }, () => {
      this.isCreating = false;
    });
  }

  updateCoupon() {
    if (this.validateEditCoupon() == false) {
      return;
    }
    this.editCouponModel.couponCalcType = this.discountTypeValue;
    this.editCouponModel.couponStartDate = this.periodDate[0];
    this.editCouponModel.couponEndDate = this.periodDate[1];
    this.editCouponModel.couponDiscountValue = Number(this.editCouponModel.couponDiscountValue);
    this.editCouponModel.couponMinimumDiscount = Number(this.editCouponModel.couponMinimumDiscount);
    this.editCouponModel.couponMaximumDiscount = this.editCouponModel.couponMaximumDiscount != null ? Number(this.editCouponModel.couponMaximumDiscount) : null;
    this.editCouponModel.couponQuotaLimit = this.editCouponModel.couponQuotaLimit != null ? Number(this.editCouponModel.couponQuotaLimit) : null;
    this.editCouponModel.couponCompanyQuotaLimit = (this.editCouponModel.couponCompanyQuotaLimit != null && this.editCouponModel.couponCompanyQuotaLimit != 0) ? Number(this.editCouponModel.couponCompanyQuotaLimit) : null;
    this.editCouponModel.createUserId = this.localStorageService.get("userSurrKey");
    this.editCouponModel.couponPackageCondition = this.packageId.map(val => val.packageSurrkey);
    this.editCouponModel.projProdSurrKey = this.productId;
    this.couponService.updateCoupon([this.editCouponModel]).subscribe(res => {
      if (res) {
        this.isSaved.emit(true);
        this.close();
      }
    });
  }

  validateCoupon() {
    var isvalid: Array<boolean> = [];
    const checkNullOrEmthy = (val: string) => (val != null && val != '' && val != undefined && val.length > 0);

    if (this.packageId != undefined && this.packageId != null && this.packageId.length > 0) {
      this.invalid.packageId = false
    } else {
      this.invalid.packageId = true
    }

    if (this.productId != undefined && this.productId != null && this.productId != 0) {
      this.invalid.productId = false
    } else {
      this.invalid.productId = true
    }

    if (checkNullOrEmthy(this.couponModel.couponCode)) {
      this.couponModel.couponCode = this.couponModel.couponCode.trim();
      if (this.couponModel.couponCode.length < 2 || this.couponModel.couponCode.length > 5) {
        this.responseCouponCode = 1004; //invalid length coupon text
        this.invalid.couponCode = true
      } else {
        this.responseCouponCode = 0;
        this.invalid.couponCode = false
      }
    } else {
      this.invalid.couponCode = true
    }

    if (this.couponModel.couponQuotaLimit != undefined && this.couponModel.couponQuotaLimit != null && this.couponModel.couponQuotaLimit > 0) {
      this.invalid.issueCountLimit = false
    } else {
      this.invalid.issueCountLimit = true
    }

    if (this.periodDate.length > 0) {
      this.invalid.period = false;
    } else {
      this.invalid.period = true;
    }

    if (checkNullOrEmthy(this.couponModel.couponDescription)) {
      this.invalid.description = false
    } else {
      this.invalid.description = true
    }

    isvalid.push(this.invalid.productId);
    isvalid.push(this.invalid.couponCode);
    isvalid.push(this.invalid.issueCountLimit);
    isvalid.push(this.invalid.period);
    isvalid.push(this.invalid.description);
    return isvalid.every(val => val == false);
  }

  validateEditCoupon() {
    var isvalid: Array<boolean> = [];
    const checkNullOrEmthy = (val: string) => (val != null && val != '' && val != undefined && val.length > 0);

    if (this.packageId != undefined && this.packageId != null && this.packageId.length > 0) {
      this.invalid.packageId = false
    } else {
      this.invalid.packageId = true
    }

    if (this.productId != undefined && this.productId != null && this.productId != 0) {
      this.invalid.productId = false
    } else {
      this.invalid.productId = true
    }

    if (checkNullOrEmthy(this.editCouponModel.couponCode)) {
      this.invalid.couponCode = false
    } else {
      this.invalid.couponCode = true
    }

    if (this.editCouponModel.couponQuotaLimit != undefined && this.editCouponModel.couponQuotaLimit != null && this.editCouponModel.couponQuotaLimit > 0) {
      this.invalid.issueCountLimit = false
    } else {
      this.invalid.issueCountLimit = true
    }

    if (this.periodDate.length > 0) {
      this.invalid.period = false;
    } else {
      this.invalid.period = true;
    }

    if (checkNullOrEmthy(this.editCouponModel.couponDescription)) {
      this.invalid.description = false
    } else {
      this.invalid.description = true
    }

    isvalid.push(this.invalid.productId);
    isvalid.push(this.invalid.couponCode);
    isvalid.push(this.invalid.issueCountLimit);
    isvalid.push(this.invalid.period);
    isvalid.push(this.invalid.description);
    return isvalid.every(val => val == false);
  }
}
